import React, { useRef, useEffect } from 'react';
import { debounce } from "../../wui-core/src/browserUtils";

export interface ResizeProps {
  throttle?: boolean;
  onResize?: (entry: ResizeObserverEntry[]) => void;
  children?: React.ReactElement;
}


const ResizeObserverComponent = (props: ResizeProps) => {
    const { throttle = true, children } = props;
    const resizeObserver = useRef<ResizeObserver | null>(null);
    const divRef = useRef<HTMLDivElement>(null);

    const createResizeObserver = () => {
        const onResize = (entry: ResizeObserverEntry[]) => {
            props.onResize?.(entry);
        };

        const resizeHandler = throttle ? debounce(onResize, 50, false) : onResize;

        let firstExec = true; // 首次监听时，立即执行一次 onResize，之前行为保持一致，避免布局类组件出现闪动的情况
        resizeObserver.current = new ResizeObserver((entry) => {
            if (firstExec) {
                firstExec = false;
                onResize(entry);
            }
            resizeHandler(entry);
        });
        resizeObserver.current?.observe(divRef.current as Element);
    };

    const destroyResizeObserver = () => {
        resizeObserver.current && resizeObserver.current.disconnect();
        resizeObserver.current = null;
    };

    useEffect(() => {
        if (!React.isValidElement(children)) {
            console.warn('The children of ResizeObserver is invalid.');
        } else {
            if (divRef.current) {
                createResizeObserver();
            }
        }

        return () => {
            destroyResizeObserver();
        }
    }, [children, divRef.current]);

    return React.cloneElement(children as React.ReactElement, { ref: divRef });
}

export default ResizeObserverComponent;
